import React from "react";
import styles from "./Footer.module.scss";
import Feedback from "../../containers/Feedback/Feedback";
import LanguageSelection from "../LanguageSelection/LanguageSelection";
import MobileUserMenu from "../MobileUserMenu/MobileUserMenu";
import { useTranslation } from "react-i18next";

type Props = {
  userName: string;
  userTitle?: string;
  languageSelectionOpen: boolean;
  setLanguageSelectionOpen: (value: boolean) => void;
  mobileUserMenuOpen: boolean;
  setMobileUserMenuOpen: (value: boolean) => void;
  isFeedbackOpen: boolean;
  setFeedbackOpen: (value: boolean) => void;
};

const Footer: React.FC<Props> = (props: Props) => {
  // eslint-disable-next-line
  const { t } = useTranslation();
  return (
    <>
      <div
        className={
          props.isFeedbackOpen || props.languageSelectionOpen || props.mobileUserMenuOpen
            ? styles.Footer
            : [styles.Footer, styles.closed].join(" ")
        }
      >
        {props.isFeedbackOpen && (
          <Feedback
            close={() => {
              props.setFeedbackOpen(false);
              props.setMobileUserMenuOpen(false);
            }}
          />
        )}
        {props.languageSelectionOpen && (
          <>
            <LanguageSelection close={() => props.setLanguageSelectionOpen(false)} />
          </>
        )}
        {props.mobileUserMenuOpen && props.isFeedbackOpen == false && (
          <>
            <MobileUserMenu
              userName={props.userName}
              userTitle={props.userTitle}
              close={() => props.setMobileUserMenuOpen(false)}
              setLanguageSelectionOpen={props.setLanguageSelectionOpen}
              setFeedbackOpen={props.setFeedbackOpen}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Footer;
